import { render, staticRenderFns } from "./OverzichtConsoles.vue?vue&type=template&id=5b7a603a&scoped=true&"
import script from "./OverzichtConsoles.vue?vue&type=script&lang=js&"
export * from "./OverzichtConsoles.vue?vue&type=script&lang=js&"
import style0 from "./OverzichtConsoles.vue?vue&type=style&index=0&id=5b7a603a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a603a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
